<template>
  <div class="button-group">
    <a :href="link" class="btn btn-sm btn-warning">Editar</a>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "HistorialTableActions",
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    link() {
      return `/#/admin/suspensiones/${this.modo}/${this.$route.params.id_cliente}/historial/${this.params.data.id_ticket}/editar`;
    },
  },
});
</script>
